import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ invoiceMilestone }) => (
    <>
      <DateTime value={invoiceMilestone.date} /> &middot; {invoiceMilestone.invoiceItem?.name} &middot;{' '}
      <Currency value={invoiceMilestone.fee} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Billing Schedule Items"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .invoiceMilestones()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete ${
        ids.length === 1 ? 'the selected billing schedule item' : `the ${ids.length} selected billing schedule items`
      }. Invoiced billing schedule items will be skipped. This action cannot be undone.`}
    </BulkActionModal>
  );
}
